import { render, staticRenderFns } from "./createOrderV2.vue?vue&type=template&id=70f4b825&scoped=true"
import script from "./createOrderV2.vue?vue&type=script&lang=js"
export * from "./createOrderV2.vue?vue&type=script&lang=js"
import style0 from "./createOrderV2.vue?vue&type=style&index=0&id=70f4b825&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f4b825",
  null
  
)

export default component.exports